import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import { ChevronLeft, RefreshCw, Search, Send, UserRound } from "lucide-react";

import { toast } from "react-toastify";



import { GlobalContext } from "../../../Context/GlobalContext";

import useBhandarewala from "../../../services/Order/UseBhandarewala";

import useContacts from "../../../services/chat/useContacts";

import useChats from "../../../services/chat/useChats";

import useTemplates from "../../../services/Whatsapp/useTemplates";

import useWhatsappNumbers from "../../../services/Whatsapp/useWhatsappNumbers";

import ChatWindow from "../../whatsapp/Chats/ChatWindow";

import SendTemplateModal from "../../whatsapp/Chats/SendTemplateModal";

import whatsappBg from "../../../images/chat_BG.png";



export const CREATE_ORDER_USER_ID = "A1437";



const DEFAULT_RESTAURANT_NUMBER = "918587052590";

const BULK_ORDER_URL = "https://catalog.anlook.com/bulk-food/setup";



const getTenDigitMobile = (value) => {

  let digits = String(value ?? "").replace(/\D/g, "");



  if (digits.startsWith("0091") && digits.length >= 14) {

    digits = digits.slice(4);

  } else if (digits.startsWith("091") && digits.length >= 13) {

    digits = digits.slice(3);

  } else if (digits.startsWith("91") && digits.length >= 12) {

    digits = digits.slice(2);

  }



  if (digits.length === 11 && digits.startsWith("0")) {

    digits = digits.slice(1);

  }



  return digits.slice(0, 10);

};



const getUrlMobile = (value) => {

  const mobile = getTenDigitMobile(value);

  return /^\d{10}$/.test(mobile) ? `91${mobile}` : mobile;

};



const getRestaurantNumberFromReceipt = (receipt = {}) => {

  const rawNumber =

    receipt?.phone_no ||

    receipt?.phoneNo ||

    receipt?.phone ||

    receipt?.mobile ||

    receipt?.mobile_no ||

    receipt?.mobileNo ||

    receipt?.restaurant_mobile ||

    receipt?.organization_mobile ||

    receipt?.shop_mobile ||

    receipt?.contact_number ||

    receipt?.contactNo ||

    receipt?.contact_no ||

    receipt?.business_mobile ||

    "";



  const normalized = getUrlMobile(rawNumber);



  return /^91\d{10}$/.test(normalized) ? normalized : DEFAULT_RESTAURANT_NUMBER;

};



const safeParseJson = (value, fallback) => {

  try {

    return JSON.parse(value);

  } catch {

    return fallback;

  }

};



const normalizeContactNumber = (value) =>

  String(value || "").replace(/\D/g, "");



const getContactName = (contact) =>

  contact?.contact_name || contact?.name || contact?.customer_name || "Unknown";



const getContactNumber = (contact) =>

  contact?.contact_number ||

  contact?.mobile ||

  contact?.phone ||

  contact?.customer_mobile ||

  "";



const getUnreadCount = (contact) =>

  Number(

    contact?.unread_count ||

      contact?.unreadCount ||

      contact?.unread ||

      contact?.message_count ||

      0,

  ) || 0;



const getLastMessage = (contact) =>

  contact?.last_message ||

  contact?.lastMessage ||

  contact?.message ||

  contact?.last_msg ||

  "Hi";



const getContactTime = (contact) => {

  const raw =

    contact?.updated_at ||

    contact?.updatedAt ||

    contact?.last_message_time ||

    contact?.lastMessageTime ||

    contact?.created_at;



  if (!raw) return "";



  const date = new Date(raw);

  if (Number.isNaN(date.getTime())) return "";



  return date.toLocaleTimeString("en-US", {

    hour: "2-digit",

    minute: "2-digit",

    hour12: true,

  });

};



const ContactAvatar = ({ contact, size = "h-8 w-8" }) => {

  const name = getContactName(contact);

  const firstLetter =

    name && name !== "Unknown" ? name.charAt(0).toUpperCase() : "";



  return (

    <div

      className={`${size} flex shrink-0 items-center justify-center rounded-full bg-slate-400 font-semibold text-white`}

    >

      {firstLetter || <UserRound size={18} />}

    </div>

  );

};



const CreateBulkOrder = ({ receiptDetails = {}, onBack }) => {

  const { userID } = useContext(GlobalContext);

  const { generateBulkOrderNumber } = useBhandarewala();



  const {

    chatContacts,

    setChatContacts,

    fetchChatContacts,

    loading: contactsLoading,

  } = useContacts();



  const { chats, loadingChats, fetchChats, sendMessage } = useChats();



  const { templates, fetchVendorTemplates, executeTemplate } =

    useTemplates(userID);

  const { whatsappNumbers } = useWhatsappNumbers();



  const [bulkOrderForm, setBulkOrderForm] = useState({ name: "", mobile: "" });

  const [bulkOrderLoading, setBulkOrderLoading] = useState(false);

  const [bulkOrderInfo, setBulkOrderInfo] = useState(null);

  const [bulkCatalogUrl, setBulkCatalogUrl] = useState("");



  const [chatPanelMode, setChatPanelMode] = useState("contacts");

  const [selectedContact, setSelectedContact] = useState(null);

  const [contactSearch, setContactSearch] = useState("");

  const [draftMessage, setDraftMessage] = useState("");

  const [sendingMessage, setSendingMessage] = useState(false);

  const [SingleWhatsApp, setSingleWhatsApp] = useState("");

  const [showSendTemplateModal, setShowSendTemplateModal] = useState(false);

  const [chatPage, setChatPage] = useState(1);

  const [chatHasMore, setChatHasMore] = useState(true);



  const lastWsMessageRef = useRef("");



  const filteredChatContacts = useMemo(() => {

    const query = contactSearch.trim().toLowerCase();

    const list = Array.isArray(chatContacts) ? chatContacts : [];



    if (!query) return list;



    return list.filter((contact) => {

      const name = String(getContactName(contact)).toLowerCase();

      const number = String(getContactNumber(contact)).toLowerCase();

      return name.includes(query) || number.includes(query);

    });

  }, [chatContacts, contactSearch]);



  useEffect(() => {

    if (!userID) return;



    const cacheKey = `chat_contacts_${userID}`;

    const cached = sessionStorage.getItem(cacheKey);



    if (cached && (!chatContacts || chatContacts.length === 0)) {

      const parsed = safeParseJson(cached, []);

      if (Array.isArray(parsed)) {

        setChatContacts(parsed);

        return;

      }

    }



    if (!cached && (!chatContacts || chatContacts.length === 0)) {

      fetchChatContacts(1, 50);

    }

  }, [userID]);



  useEffect(() => {

    if (!userID || !selectedContact) return;



    const contactNumber = getContactNumber(selectedContact);

    if (!contactNumber) return;



    const socket = new WebSocket(

      `wss://payinnew\.remittpe.com/ws?userId=${userID}&roomId=${contactNumber}`,

    );



    socket.onmessage = (event) => {

      if (lastWsMessageRef.current === event.data) return;

      lastWsMessageRef.current = event.data;

      fetchChats(contactNumber, 1);

    };



    return () => socket.close();

  }, [userID, selectedContact]);



  useEffect(() => {

    if (!SingleWhatsApp) return;

    fetchVendorTemplates(SingleWhatsApp);

  }, [SingleWhatsApp]);



  const updateBulkOrderField = (field, value) => {

    if (bulkOrderInfo) return;



    setBulkOrderForm((prev) => ({

      ...prev,

      [field]: field === "mobile" ? getTenDigitMobile(value) : value,

    }));

  };



  const handleStartBulkOrder = async (event) => {

    event?.preventDefault?.();



    if (bulkOrderLoading || bulkOrderInfo) return;



    if (String(userID || "") !== CREATE_ORDER_USER_ID) {

      toast.error("Create Order is not available for this user");

      return;

    }



    const name = bulkOrderForm.name.trim();

    const customerMobile = getTenDigitMobile(bulkOrderForm.mobile);



    if (!name) {

      toast.error("Please enter customer name");

      return;

    }



    if (!/^\d{10}$/.test(customerMobile)) {

      toast.error("Enter valid 10 digit mobile number");

      return;

    }



    try {

      setBulkOrderLoading(true);



      const result = await generateBulkOrderNumber({

        userID,

        mobile: customerMobile,

      });



      if (!result?.success || !result?.orderId) {

        toast.error(result?.message || "Unable to generate bulk order number");

        return;

      }



      const restaurantNumber = getRestaurantNumberFromReceipt(receiptDetails);

      const url = new URL(BULK_ORDER_URL);



      url.searchParams.set("mobile", `91${customerMobile}`);

      url.searchParams.set("userid", userID);

      url.searchParams.set("orderid", result.orderId);

      url.searchParams.set("restaurantNumber", restaurantNumber);

      url.searchParams.set("orderType", "home_delivery");

      url.searchParams.set("orderFrom", "chaafo");

      url.searchParams.set("name", name);

      url.searchParams.set("isReferred", "true");



      setBulkOrderInfo({

        orderId: String(result.orderId),

        name,

        mobile: customerMobile,

      });

      setBulkOrderForm({ name, mobile: customerMobile });

      setBulkCatalogUrl(url.toString());

      setChatPanelMode("contacts");

    } catch (error) {

      console.error("Create bulk order error:", error);

      toast.error(error?.message || "Unable to start order");

    } finally {

      setBulkOrderLoading(false);

    }

  };



  const handleSelectChatContact = async (contact) => {

    const contactNumber = getContactNumber(contact);



    if (!contactNumber) {

      toast.error("Contact number is missing");

      return;

    }



    setSelectedContact(contact);

    setChatPanelMode("chat");

    setChatPage(1);

    setChatHasMore(true);

    setDraftMessage("");



    try {

      await fetchChats(contactNumber, 1);

    } catch (error) {

      console.error("Chat load error:", error);

      toast.error("Unable to load chat");

    }

  };



  const handleFetchMoreChats = async () => {

    if (!selectedContact || loadingChats || !chatHasMore) return;



    const contactNumber = getContactNumber(selectedContact);

    const nextPage = chatPage + 1;

    const res = await fetchChats(contactNumber, nextPage);



    if (!res?.data || res.data.length === 0) {

      setChatHasMore(false);

      return;

    }



    setChatPage(nextPage);

  };



  const handleSendChatMessage = async (event) => {

    event?.preventDefault?.();



    if (!selectedContact || !draftMessage.trim() || sendingMessage) return;



    const contactNumber = getContactNumber(selectedContact);

    const message = draftMessage.trim();



    try {

      setSendingMessage(true);

      await sendMessage(contactNumber, message);

      setDraftMessage("");

      await fetchChats(contactNumber, 1);

    } catch (error) {

      console.error("Send message error:", error);

      toast.error("Unable to send message");

    } finally {

      setSendingMessage(false);

    }

  };



  const handleOpenSendNew = () => {

    const phoneId =

      SingleWhatsApp ||

      (whatsappNumbers?.length > 0 ? whatsappNumbers[0].phone_no_id : "");



    if (!phoneId) {

      console.error("No WhatsApp number found");

      return;

    }



    setSingleWhatsApp(phoneId);

    fetchVendorTemplates(phoneId);

    setShowSendTemplateModal(true);

  };



  const handleRefreshChatContacts = async () => {

    try {

      await fetchChatContacts(1, 50, true);

    } catch (error) {

      console.error("Contacts refresh error:", error);

    }

  };



  return (

    <div className="flex h-full min-h-0 flex-1 flex-col overflow-hidden bg-white">

      <form

        onSubmit={handleStartBulkOrder}

        className="shrink-0 border-b border-gray-200 bg-white px-1 py-1"

      >

        <div className="flex h-9 items-center gap-2 overflow-hidden whitespace-nowrap">

          <button

            type="button"

            onClick={onBack}

            className="inline-flex h-7 shrink-0 items-center gap-0.5 rounded border border-gray-300 bg-white px-1.5 text-[10px] font-medium text-gray-700 transition hover:bg-gray-50"

          >

            <ChevronLeft size={12} />

            Back to Orders

          </button>



          <div className="flex shrink-0 items-center gap-1.5 px-1">

            <span className="text-[11px] font-semibold text-gray-800">

              Create Bulk Order

            </span>

            {bulkOrderInfo && (

              <span className="text-[9px] font-medium text-emerald-600">

                #{bulkOrderInfo.orderId}

              </span>

            )}

          </div>



          <label className="flex shrink-0 items-center gap-1.5">

            <span className="text-[9px] font-semibold text-gray-600">

              Customer Name

            </span>

            <input

              type="text"

              value={bulkOrderForm.name}

              onChange={(event) =>

                updateBulkOrderField("name", event.target.value)

              }

              placeholder="Enter customer name"

              disabled={bulkOrderLoading || Boolean(bulkOrderInfo)}

              className="h-7 w-[180px] rounded border border-gray-300 px-2 text-[11px] outline-none transition focus:border-emerald-500 focus:ring-1 focus:ring-emerald-100 disabled:bg-gray-100 disabled:text-gray-600 xl:w-[200px]"

            />

          </label>



          <label className="flex shrink-0 items-center gap-1.5">

            <span className="text-[9px] font-semibold text-gray-600">

              Mobile Number

            </span>

            <input

              type="tel"

              inputMode="numeric"

              value={bulkOrderForm.mobile}

              onChange={(event) =>

                updateBulkOrderField("mobile", event.target.value)

              }

              placeholder="9876543210"

              disabled={bulkOrderLoading || Boolean(bulkOrderInfo)}

              className="h-7 w-[120px] rounded border border-gray-300 px-2 text-[11px] outline-none transition focus:border-emerald-500 focus:ring-1 focus:ring-emerald-100 disabled:bg-gray-100 disabled:text-gray-600 xl:w-[130px]"

            />

          </label>



          <button

            type="submit"

            disabled={bulkOrderLoading || Boolean(bulkOrderInfo)}

            className="inline-flex h-7 min-w-[78px] shrink-0 items-center justify-center rounded bg-emerald-600 px-2 text-[10px] font-semibold text-white transition hover:bg-emerald-700 disabled:cursor-not-allowed disabled:opacity-60"

          >

            {bulkOrderLoading

              ? "Starting..."

              : bulkOrderInfo

                ? "Started"

                : "Start Order"}

          </button>

        </div>

      </form>



      <div className="grid min-h-0 flex-1 overflow-hidden lg:grid-cols-[minmax(0,1fr)_250px] xl:grid-cols-[minmax(0,1fr)_270px] 2xl:grid-cols-[minmax(0,1fr)_290px]">

        <section className="flex min-h-0 min-w-0 flex-col overflow-hidden bg-[#f4f8f6]">

          {bulkCatalogUrl ? (
            <>
              {process.env.NODE_ENV === "development" && (
                <div className="shrink-0 border-b border-amber-300 bg-amber-50 px-1 py-2">
                  <div className="flex items-center gap-2">
                    <span className="inline-flex h-7 shrink-0 items-center rounded bg-amber-200 px-2 text-[10px] font-bold text-amber-700">
                      DEV URL
                    </span>

                    <div
                      className="flex h-8 min-w-0 flex-1 items-center overflow-hidden rounded-md border border-amber-300 bg-white px-3 text-[11px] text-slate-700"
                      title={bulkCatalogUrl}
                    >
                      <span className="truncate">{bulkCatalogUrl}</span>
                    </div>

                    <button
                      type="button"
                      onClick={async () => {
                        try {
                          await navigator.clipboard.writeText(bulkCatalogUrl);
                          toast.success("URL copied");
                        } catch {
                          toast.error("Unable to copy URL");
                        }
                      }}
                      className="h-9 shrink-0 rounded-md bg-amber-500 px-3 text-[11px] font-bold text-white transition hover:bg-amber-600"
                    >
                      Copy URL
                    </button>
                  </div>

                  <p className="mt-1 text-[9px] text-amber-700">
                    Development only — this URL is hidden automatically in production.
                  </p>
                </div>
              )}

              <div className="min-h-0 flex-1 overflow-hidden">
                <iframe
                  src={bulkCatalogUrl}
                  title="Bulk food catalogue"
                  className="border-0"
                  style={{
                    width: "111.12%",
                    height: "111.12%",
                    transform: "scale(0.9)",
                    transformOrigin: "top left",
                  }}
                  allow="clipboard-read; clipboard-write"
                  referrerPolicy="strict-origin-when-cross-origin"
                />
              </div>
            </>
          ) : (
            <div className="h-full w-full bg-[#f4f8f6]" />
          )}

        </section>



        <aside className="flex min-h-0 min-w-0 flex-col overflow-hidden border-l border-gray-200 bg-white">

          {chatPanelMode === "contacts" && (

            <div className="flex min-h-0 flex-1 flex-col overflow-hidden bg-white">

              <div className="flex h-10 shrink-0 items-center justify-between border-b px-2">

                <div className="min-w-0">

                  <p className="truncate text-[10px] font-bold tracking-wide text-slate-500">

                    RECENT CHATS

                  </p>

                  <p className="truncate text-[9px] text-gray-400">

                    Select contact

                  </p>

                </div>



                <div className="flex items-center gap-1">

                  <button

                    type="button"

                    onClick={handleOpenSendNew}

                    className="text-[10px] font-medium text-[#047a4b] hover:text-blue-700"

                    title="Send New"

                  >

                    Send New

                  </button>



                  <button

                    type="button"

                    onClick={handleRefreshChatContacts}

                    disabled={contactsLoading}

                    className="flex h-6 w-6 items-center justify-center rounded border border-gray-200 text-emerald-600 hover:bg-gray-50 disabled:opacity-50"

                    title="Refresh contacts"

                  >

                    <RefreshCw

                      size={12}

                      className={contactsLoading ? "animate-spin" : ""}

                    />

                  </button>

                </div>

              </div>



              <div className="shrink-0 border-b p-1.5">

                <div className="flex h-7 items-center gap-1.5 rounded-md border border-gray-200 bg-gray-50 px-2 focus-within:border-emerald-400 focus-within:bg-white">

                  <Search size={12} className="text-gray-400" />

                  <input

                    type="text"

                    value={contactSearch}

                    onChange={(event) => setContactSearch(event.target.value)}

                    placeholder="Search contact..."

                    className="min-w-0 flex-1 bg-transparent text-[11px] outline-none"

                  />

                </div>

              </div>



              <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain bg-white">

                {contactsLoading && filteredChatContacts.length === 0 ? (

                  <div className="flex h-20 items-center justify-center text-[10px] text-gray-400">

                    Loading contacts...

                  </div>

                ) : filteredChatContacts.length === 0 ? (

                  <div className="flex h-20 items-center justify-center px-2 text-center text-[10px] text-gray-400">

                    No chat contacts found.

                  </div>

                ) : (

                  filteredChatContacts.map((contact, index) => {

                    const number = getContactNumber(contact);

                    const name = getContactName(contact);

                    const unread = getUnreadCount(contact);

                    const isSelected =

                      normalizeContactNumber(number) ===

                      normalizeContactNumber(getContactNumber(selectedContact));



                    return (

                      <button

                        key={contact?.id || number || index}

                        type="button"

                        onClick={() => handleSelectChatContact(contact)}

                        className={`flex w-full items-center gap-1.5 border-b px-2 py-1.5 text-left transition hover:bg-gray-50 ${

                          isSelected ? "bg-emerald-50" : "bg-white"

                        }`}

                      >

                        <ContactAvatar contact={contact} size="h-7 w-7" />



                        <div className="min-w-0 flex-1">

                          <div className="flex items-center justify-between gap-1">

                            <p className="truncate text-[11px] font-medium text-gray-800">

                              {name}

                              {number ? ` | ${number}` : ""}

                            </p>

                            {unread > 0 && (

                              <span className="inline-flex min-w-4 items-center justify-center rounded-full bg-emerald-500 px-1 py-0.5 text-[8px] font-bold text-white">

                                {unread > 99 ? "99+" : unread}

                              </span>

                            )}

                          </div>



                          <div className="mt-0.5 flex items-center justify-between gap-1">

                            <p className="truncate text-[9px] text-gray-500">

                              {getLastMessage(contact)}

                            </p>

                            <span className="shrink-0 text-[8px] text-gray-400">

                              {getContactTime(contact)}

                            </span>

                          </div>

                        </div>

                      </button>

                    );

                  })

                )}

              </div>

            </div>

          )}



          {chatPanelMode === "chat" && selectedContact && (

            <div className="flex min-h-0 flex-1 flex-col overflow-hidden bg-white">

              <div className="flex h-10 shrink-0 items-center gap-1.5 border-b bg-emerald-600 px-1.5 text-white">

                <button

                  type="button"

                  onClick={() => setChatPanelMode("contacts")}

                  className="flex h-6 w-6 items-center justify-center rounded-full hover:bg-white/15"

                  title="Back to contacts"

                >

                  <ChevronLeft size={15} />

                </button>



                <ContactAvatar contact={selectedContact} size="h-7 w-7" />



                <div className="min-w-0 flex-1">

                  <p className="truncate text-[11px] font-semibold">

                    {getContactName(selectedContact)}

                  </p>

                  <p className="truncate text-[9px] text-emerald-50">

                    {getContactNumber(selectedContact)}

                  </p>

                </div>

              </div>



              <div className="relative min-h-0 flex-1 overflow-hidden bg-[#fff8e8]">

                <div

                  className="absolute inset-0 bg-repeat bg-center opacity-60"

                  style={{ backgroundImage: `url(${whatsappBg})` }}

                />

                <div className="absolute inset-0 overflow-y-auto overscroll-contain text-[11px]">

                  <ChatWindow

                    chats={chats}

                    isLoadingChats={loadingChats}

                    chatHasMore={chatHasMore}

                    fetchMoreChats={handleFetchMoreChats}

                  />

                </div>

              </div>



              <form

                onSubmit={handleSendChatMessage}

                className="flex shrink-0 items-center gap-1.5 border-t bg-white p-1.5"

              >

                <input

                  type="text"

                  value={draftMessage}

                  onChange={(event) => setDraftMessage(event.target.value)}

                  placeholder="Type a message"

                  className="h-8 min-w-0 flex-1 rounded-md border border-gray-200 px-2 text-[11px] outline-none focus:border-emerald-400 focus:ring-1 focus:ring-emerald-100"

                />



                <button

                  type="submit"

                  disabled={!draftMessage.trim() || sendingMessage}

                  className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-emerald-500 text-white transition hover:bg-emerald-600 disabled:cursor-not-allowed disabled:opacity-50"

                  title="Send message"

                >

                  <Send size={14} />

                </button>

              </form>

            </div>

          )}

        </aside>

      </div>



      <SendTemplateModal

        show={showSendTemplateModal}

        onClose={() => setShowSendTemplateModal(false)}

        whatsappNumbers={whatsappNumbers}

        SingleWhatsApp={SingleWhatsApp}

        setSingleWhatsApp={setSingleWhatsApp}

        templates={templates}

        fetchVendorTemplates={fetchVendorTemplates}

        executeTemplate={executeTemplate}

        userID={userID}

      />

    </div>

  );

};



export default CreateBulkOrder;